import { Field, FieldInputProps } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';

const FormCheckRadio: React.FC<{
  field: FieldInputProps<any>;
  dataCy?: string;
  handleChange: (fieldName: string, fieldValue: any) => void;
  isInvalid: (fieldName: string) => boolean | undefined;
}> = ({ field, dataCy, handleChange, isInvalid }) => {
  const hasError = !!isInvalid(field.name);
  const onChange = (e: any) =>
    handleChange(field.name, e.target.value === 'true');

  return (
    <div
      className={`form-check-radio-group${
        hasError ? ' is-invalid-radio-group' : ''
      }`}
    >
      <Form.Check inline>
        <Field
          data-cy={`${dataCy}-true`}
          as={Form.Check.Input}
          type="radio"
          id={field.name}
          name={field.name}
          value={true}
          onChange={onChange}
          isInvalid={hasError}
        />
        <Form.Check.Label htmlFor={field.name}>Sim</Form.Check.Label>
      </Form.Check>

      <Form.Check inline>
        <Field
          data-cy={`${dataCy}-false`}
          as={Form.Check.Input}
          type="radio"
          id={field.name}
          name={field.name}
          value={false}
          onChange={onChange}
          isInvalid={hasError}
        />
        <Form.Check.Label htmlFor={field.name}>Não</Form.Check.Label>
      </Form.Check>
    </div>
  );
};

export default FormCheckRadio;
